var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"arrowbutton",class:("direction-" + _vm.direction),on:{"click":function($event){$event.preventDefault();return _vm.goDown($event)}}},[_c('ArrowIcon'),(_vm.text)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }